import { render, staticRenderFns } from "./FormToggleListElement.vue?vue&type=template&id=52b46c2a&scoped=true"
import script from "./FormToggleListElement.vue?vue&type=script&lang=js"
export * from "./FormToggleListElement.vue?vue&type=script&lang=js"
import style0 from "./FormToggleListElement.vue?vue&type=style&index=0&id=52b46c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b46c2a",
  null
  
)

export default component.exports